<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M4.875 21.4643V12.5357C4.875 11.9834 5.32271 11.5357 5.875 11.5357H11.8099C12.037 11.5357 12.2573 11.4584 12.4346 11.3166L19.6432 5.54976C20.2979 5.02595 21.2679 5.49212 21.2679 6.33063V27.6694C21.2679 28.5079 20.2979 28.9741 19.6432 28.4502L12.4346 22.6834C12.2573 22.5416 12.037 22.4643 11.8099 22.4643H5.875C5.32272 22.4643 4.875 22.0166 4.875 21.4643Z"
			:fill="props.iconColor"
		/>
		<ellipse cx="24.7096" cy="14.1667" rx="1.41667" ry="1.41667" :fill="props.iconColor" />
		<circle cx="24.9162" cy="19.5642" r="1.41667" transform="rotate(75 24.9162 19.5642)" :fill="props.iconColor" />
		<ellipse cx="28.9596" cy="11.3337" rx="1.41667" ry="1.41667" :fill="props.iconColor" />
		<circle cx="28.7522" cy="22.9362" r="1.41667" transform="rotate(75 28.7522 22.9362)" :fill="props.iconColor" />
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 34,
		height: 34,
		iconColor: '#ffff',
	}
);
</script>

<style lang="scss" scoped></style>
